<script>
  import FeedbackForm from "./FeedbackForm.svelte";
  import { fade } from "svelte/transition";
	import { isOpen } from './stores.js';

  export let sid;
  export let surl;

  let isopen
  // console.log(sid, surl);
  isOpen.subscribe(value => {
		isopen = value;
	});

  function handleKeyPress(event) {
    if (event.key === "Enter") {
      // Trigger the same action as the onclick event
      event.target.click;
    }
  }

  function toggleOpen() {
    if (isopen == true) {
      isopen = false;
      isOpen.set(false);
    } else {
      isopen = true;
      isOpen.set(true);
    }
  }

  function close() {
    isopen = false;
    isOpen.set(false);
  }

  
</script>

<svelte:options tag="ctgov-global-feedback"></svelte:options>

{#if isopen}
    <div transition:fade class="backdrop" on:click={close} />
  {/if}


<div id="feedback_1" class="feedback">
  <button class="feedback__btn btn" on:click={toggleOpen} on:keydown={handleKeyPress} tab-index="0" aria-label="Give Feedback, Opens a new Dialog"> 
    Feedback     
    <span class="feedback__icon icon {!isopen ? 'plus-icon' : ''} " />
  </button>
  <feedback-form isopen={isopen} surveyid={sid} surveyurl={surl} on:focusout={close}></feedback-form>
</div>

<style>

   /* @font-face{font-family:"Karla-Regular";src:url("https://egov.ct.gov/sitecore-global-feedback/client/build/css/fonts/Karla-Regular.ttf")}@font-face{font-family:"Karla-Bold";src:url("https://egov.ct.gov/sitecore-global-feedback/client/build/css/fonts/Karla-Bold.ttf")}@font-face{font-family:"Karla-Italic";src:url("https://egov.ct.gov/sitecore-global-feedback/client/build/css/fonts/Karla-Italic.ttf")}@font-face{font-family:"Karla-BoldItalic";src:url("https://egov.ct.gov/sitecore-global-feedback/client/build/css/fonts/Karla-BoldItalic.ttf")}@font-face{font-family:"Lato-Regular";src:url("https://egov.ct.gov/sitecore-global-feedback/client/build/css/fonts/Lato-Regular.ttf")}@font-face{font-family:"Lato-Bold";src:url("https://egov.ct.gov/sitecore-global-feedback/client/build/css/fonts/Lato-Bold.ttf")}@font-face{font-family:"Lato-Italic";src:url("https://egov.ct.gov/sitecore-global-feedback/client/build/css/fonts/Lato-Italic.ttf")}@font-face{font-family:"Lato-BoldItalic";src:url("https://egov.ct.gov/sitecore-global-feedback/client/build/css/fonts/Lato-BoldItalic.ttf")}@font-face{font-family:"Lato-Light";src:url("https://egov.ct.gov/sitecore-global-feedback/client/build/css/fonts/Lato-Light.ttf")}@font-face{font-family:"Lato-Thin";src:url("https://egov.ct.gov/sitecore-global-feedback/client/build/css/fonts/Lato-Thin.ttf")}@font-face{font-family:"Lato-Black";src:url("https://egov.ct.gov/sitecore-global-feedback/client/build/css/fonts/Lato-Black.ttf")} */

  .backdrop { 
    position: fixed;
    top:0;
    bottom:0;
    left:0;
    right:0;
    /* width: 100%;
    height: 100%; */
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 999999997;
  }
  .feedback {
    position: fixed;
    z-index: 999999998;
    overflow: hidden;
  }


  .feedback__btn {
    top: 12rem;
    right: 9.5rem;
    transform-origin: top right;
    transform: translate(100%, 0) rotate(-90deg);
    z-index: 999999999;
    position: fixed;
    transition: all 0.2s ease-in-out;
    padding: 0.5em 1em 3.5em;
    background: #BA5803;
    color: #fff;
    width:7rem;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    cursor: pointer;
    border-radius: 3px;
    transition: all 0.2s ease-in-out;
    border: none;
    font-family: "Karla-Bold", -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    font-size: 0.75rem;
    font-weight: normal;
    line-height: 0.875rem;
    letter-spacing: 0.03188rem;
    text-transform: uppercase;
    display: block;
    text-align: center;
    float:right;
  }

  @media (max-width: 767.98px) {
    .feedback__btn {
      top: 40vh;
    }
  }

  .feedback__btn:hover {
    right: 10.5rem;
    color: #fff;
  }

  .feedback__icon:after {
    content: "\00D7";
  }

  .plus-icon:after {
    content: "+";
  }

  .plus-icon:before {
    content: "+";
    position: absolute;
    margin-top: -1px;
  }

  .plus-icon:before {
    -webkit-animation: pulse 2s ease-in;
    -moz-animation: pulse 2s ease-in;
    animation: pulse 2s ease-in;
    -webkit-animation-iteration-count: infinite;
    -moz-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
  }

  @keyframes pulse {
    0% {
      -webkit-transform: scale(1);
      opacity: 0;
    }

    25% {
      -webkit-transform: scale(1.5);
      opacity: 0.1;
    }

    50% {
      -webkit-transform: scale(1.8);
      opacity: 0.5;
    }

    75% {
      -webkit-transform: scale(2.2);
      opacity: 0.1;
    }

    100% {
      -webkit-transform: scale(2.6);
      opacity: 0;
    }
  }
</style>
